import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Programme = { titleKey: string; metaKey: string; descKey: string; altKey: string; img: string };

const programmes: Programme[] = [
  {
    titleKey: 'aboutAcademy.programme.1.title',
    metaKey: 'aboutAcademy.programme.1.meta',
    descKey: 'aboutAcademy.programme.1.desc',
    altKey: 'aboutAcademy.programme.1.imgAlt',
    img: '/images/generated/essential-ironing-2026.jpg',
  },
  {
    titleKey: 'aboutAcademy.programme.2.title',
    metaKey: 'aboutAcademy.programme.2.meta',
    descKey: 'aboutAcademy.programme.2.desc',
    altKey: 'aboutAcademy.programme.2.imgAlt',
    img: '/images/generated/advanced-candlelight-2026.jpg',
  },
  {
    titleKey: 'aboutAcademy.programme.3.title',
    metaKey: 'aboutAcademy.programme.3.meta',
    descKey: 'aboutAcademy.programme.3.desc',
    altKey: 'aboutAcademy.programme.3.imgAlt',
    img: '/images/generated/master-vip-2026.jpg',
  },
];

export default function ProgrammeOverview() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('aboutAcademy.programme.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('aboutAcademy.programme.title')}
          </h2>
          {String(t('aboutAcademy.programme.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('aboutAcademy.programme.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[2] max-w-[760px] mx-auto text-left md:text-center">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {programmes.map((programme) => (
            <div
              key={programme.titleKey}
              className="card-glow bg-background-50 border border-background-200/60 overflow-hidden flex flex-col cursor-default"
            >
              <img
                src={programme.img}
                alt={t(programme.altKey)}
                className="w-full aspect-[4/3] object-cover object-center"
                loading="lazy"
              />
              <div className="p-6 md:p-7 flex flex-col flex-1">
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                  {t(programme.titleKey)}
                </h3>
                {String(t(programme.metaKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-accent-600 tracking-[0.08em] mb-3">{__s}</p>))}
                {String(t(programme.descKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.95]">{__s}</p>))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            <span>{t('aboutAcademy.programme.link')}</span>
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
